var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full pa-sm-3"},[_c('ContentCreator')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }